<div
	class="loading-overlay"
	*ngIf="isLoading">
	<div class="k-i-loading">
		<p>Completing sign-in&hellip;</p>
	</div>
</div>
